<template>
  <div class="Contact" style="position:fixed">
      <b-container fluid style="padding-top: 100px; ">
        <b-row>
          <b-col cols="12 headerF"><HeaderFixed/></b-col>
          <b-col cols="12 headerM"><HeaderMobile/></b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
              <b-breadcrumb style=" background-color: #e9ecef78;">

                  <b-breadcrumb-item href="#home">
                    <router-link to="/Assamese">
                        <b-icon icon="house-door" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon>
                        মূখ্যপৃষ্ঠা
                    </router-link>
                  </b-breadcrumb-item>

                 <b-breadcrumb-item href="#" active>সততে উত্থাপিত প্ৰশ্নসমূহ</b-breadcrumb-item>
              </b-breadcrumb>
            </b-col>
        </b-row>

        <b-row>
          <b-col col cols="12" sm="3" md="3" lg="3" class="sideNav">
              <FAQSideNav />
          </b-col>
          <b-col col cols="12" sm="12" md="12" lg="3" class="dropdownmenu">
              <FAQMobileDropDown/><br>
          </b-col>
          <b-col col cols="12" sm="12" md="12" lg="9" style="height:75vh; overflow-y:scroll " class="shadow">
            <FAQContent />
          </b-col>
        </b-row>
      </b-container>
      <br><br>
  </div>
</template>

<script>
import FAQSideNav from '@/components/FAQSideNav.vue'
import FAQMobileDropDown from '@/components/FAQMobileDropDown.vue'
import FAQContent from '@/components/FAQContent.vue'
import HeaderFixed from '@/components/AS_HeaderFixed.vue'
import HeaderMobile from '@/components/AS_HeaderMobile.vue'

export default {
  name: 'Contact',
  components: {
    'FAQSideNav' : FAQSideNav,
    'FAQMobileDropDown' : FAQMobileDropDown,
    'FAQContent' : FAQContent,
      'HeaderFixed' : HeaderFixed,
      'HeaderMobile' : HeaderMobile
    }
}


</script>

<style scoped="true">
li{
  padding:0;
}

    body{
      overflow-y:hidden;
    }
    .headerF{
      display: block;
    }
    .headerM{
      display: none;
    }
    .sideNav{
      height:75vh;
      overflow-y:scroll;
    }
    .dropdownmenu{
      display: none;
    }
    @media (max-width: 768px) {
        .headerF{
          display: none;
        }
        .headerM{
          display: block;
        }
        .sideNav{
          /* height:50vh;
          overflow-y:hidden; */
          display: none
        }
        .dropdownmenu{
          display: block;
        }
      }
      @media (max-width: 576px) {
        .sideNav{
          /* height:50vh;
          overflow-y:hidden; */
          display: none
        }
        .dropdownmenu{
          display: block;
        }
      }
      @font-face {
        font-family: Assamese_Font;
        src: url("../assets/Assamese_font/KirtanUni.ttf");
      }
      div{
          font-family: arial,Assamese_Font;
      }
</style>
